import { render, staticRenderFns } from "./ModifyGrade.vue?vue&type=template&id=625e88c2&scoped=true&"
import script from "./ModifyGrade.vue?vue&type=script&lang=js&"
export * from "./ModifyGrade.vue?vue&type=script&lang=js&"
import style0 from "./ModifyGrade.vue?vue&type=style&index=0&id=625e88c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625e88c2",
  null
  
)

export default component.exports